module.exports = __webpack_public_path__ + "img/icon_information_white.27993563.svg";